import React from "react";
import {
  Divider,
  Button,
  Grid,
  LinearProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  Typography,
} from "@material-ui/core";
import { TextField } from "formik-material-ui";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import RichTextEditor from "react-rte";
import { ReportNoteList } from "./ReportNoteList";
import { useFetchContext } from "../../../common/FetchContext";
import { useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { processErrorOnMutation } from "../../../../util/errorMessaging";
import { urls } from "../../../common/urls";
import IdButton from "../../../common/IdButton";
import { useReportWriterNote } from "../../../common/CommonMutations";




export const ReportNotes = ({ count,
  type,
  id,
  unreadNotes,
  invalidate,
  getNotes,
  url,
  model }: any) => {

  const { authAxios } = useFetchContext();

  const [open, setOpen] = React.useState(false);
  const [noteListOpen, setNoteListOpen] = React.useState(false);
  const [isFirstClick, setIsFirstClick] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(false);
  const [noteId, setNoteid] = React.useState(0);


  const [reportdata, setreportData] = React.useState({ data: [] });
  const [err, setErr] = React.useState('');

  const handleToggleDialog = () => setOpen(!open);

  const getProjectNotes = async (): Promise<any> => {
    try {
      var data = await authAxios.get(urls.reportWriterAgenda.getnotes(id));
      setIsLoading(false)
      setreportData(data);
    } catch (err) {
      setIsLoading(false)
      setErr('error');
    }
  };

  // const {
  //   data: reportdatas,
  //   // isLoadingreports ,
  //   isFetching,
  //   error,
  //   refetch,
  // } = useReportNotes(id, false);

  const handleInitialLoad = () => {

    setIsFirstClick(false)
    setIsLoading(true)
    getProjectNotes()
  };



  if (isLoading) {
    return (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <LinearProgress />
        </Grid>
      </Grid>
    );
  }

  if (isFirstClick) {
    return (
      <Button color="inherit" onClick={handleInitialLoad} fullWidth>
        Click Notes
      </Button>
    );
  }

  return (
    <div>
      <Button
        style={{ textAlign: "center" }}
        variant="contained"
        color="primary"
        onClick={handleToggleDialog}
        fullWidth
      >
        Notes ({reportdata?.data?.length || 0})
      </Button>

      <Dialog open={open} onClose={handleToggleDialog} fullWidth maxWidth="md">
        <DialogTitle>Attached Notes</DialogTitle>
        <DialogContent>
          <Divider />
          {reportdata.data.length === 0 ? (
            <Typography variant="body2">No notes yet.</Typography>
          ) : (
            <ReportNoteList type={type} getNotes={getNotes} markRead={false} id={id} />

          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleToggleDialog} color="primary">
            Close
          </Button>
          <PostNewNote

            id={id}
            type={type}
            invalidate={invalidate}
            url={url}
            // getNotes={getNotes}
            getNotes={getProjectNotes} 
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

const PostNewNote = (
  { id, type, invalidate, url, getNotes }: any) => {
  const [open, setOpen] = React.useState(false);
  const [text, setText] = React.useState(RichTextEditor.createEmptyValue());
  const { authAxios } = useFetchContext();
  const queryClient = useQueryClient();
  const { mutateAsync: mutate } = useReportWriterNote();

  const handleToggleDialog = () => setOpen(!open);

  const handleChange = (value: any) => setText(value);

  return (
    <div>
      <Button color="primary" onClick={handleToggleDialog}>
        Add Note
      </Button>

      <Formik
        initialValues={{ subject: "" }}
        validationSchema={Yup.object({
          subject: Yup.string().required("Field must be required"),
        })}
        onSubmit={async (values, { resetForm }) => {
          try {

            await mutate({

              authAxios,
              type: type,
              subject: values.subject,
              comment: text.toString("markdown"),
              report: id,

            });


            for (const value in invalidate) {
              queryClient.invalidateQueries(invalidate[value]);
            }

            await getNotes();

            toast.success("Note successfully added.");
            handleToggleDialog();
            resetForm();
            setText(RichTextEditor.createEmptyValue());
          } catch (err) {
            toast.error("Note failed to be added");
            processErrorOnMutation(err);
          }
        }}
      >
        {({ errors, touched, submitForm }) => (
          <Form>
            <Dialog open={open} onClose={handleToggleDialog} fullWidth maxWidth="md">
              <DialogTitle>
                <Field
                  name="subject"
                  helperText={touched.subject ? errors.subject : ""}
                  error={touched.subject && Boolean(errors.subject)}
                  component={TextField}
                  label="Note Subject"
                  placeholder="Add a Subject"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
              </DialogTitle>
              <DialogContent dividers>
                <RichTextEditor value={text} onChange={handleChange} />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleToggleDialog} color="secondary">
                  Cancel
                </Button>
                <Button onClick={submitForm} color="primary">
                  Submit
                </Button>
              </DialogActions>
            </Dialog>
          </Form>
        )}
      </Formik>
    </div>
  );
};


